/* eslint-disable react/prop-types */
import { Box, Modal, Typography } from "@mui/material";
import SoftButton from "components/SoftButton";
import SwitchBox from "components/SwitchBox";
import React from "react";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  minWidth: 400,
  bgcolor: "background.paper",
  border: "none",
  outline: "none",
  boxShadow: 24,
  borderRadius: 1,
  p: 1,
};

function Button({ children, ...rest }) {
  return (
    <button
      style={{
        padding: "4px 10px",
      }}
      {...rest}
    >
      {children}
    </button>
  );
}

const Actions = ({ list, pickAll, setPickAll, handleChangeSwitch }) => {
  const [open, setOpen] = React.useState(false);

  const handleClose = () => setOpen(false);

  return (
    <div
      style={{
        position: "fixed",
        bottom: 0,
        right: 0,
        minWidth: 300,
        zIndex: 1,
        border: "1px solid black",
        background: "#fff",
        display: "flex",
        gap: 5,
        padding: 4,
      }}
    >
      <Button onClick={() => setOpen(true)}>Thêm phụ lục</Button>
      <Button>Nhập lại</Button>
      <Button>Ghi</Button>
      <Button>In</Button>
      <Button>Xóa</Button>
      <Button>Kết xuất</Button>
      <Button>Nhập từ XML</Button>
      <Button>Đóng</Button>

      <Modal
        open={open}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <Box
            sx={{
              p: 1,
              border: "1px solid black",
              borderRadius: 1,
            }}
          >
            <Typography id="modal-modal-title" variant="h6" component="h2">
              Thêm phụ lục kê khai
            </Typography>
          </Box>
          <Box
            sx={{
              p: 1,
              border: "1px solid black",
              borderRadius: 1,
              mt: 1,
            }}
          >
            <SwitchBox
              checked={pickAll}
              onChange={(e) => setPickAll(e.target.checked)}
              label="Chọn phụ lục kê khai"
            />
            <Box
              sx={{
                mt: 1,
                p: 1,
                maxHeight: 200,
                overflow: "auto",
                borderRadius: 1,
                border: "1px solid black",
              }}
            >
              {list.map((item, index) => (
                <SwitchBox
                  key={index}
                  name={item.name}
                  checked={pickAll ? pickAll : item.checked}
                  onChange={(e) => handleChangeSwitch(item.name, e.target.checked)}
                  label={item.name}
                />
              ))}
            </Box>
          </Box>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              gap: 2,
              mt: 2,
            }}
          >
            <SoftButton onClick={handleClose} color="dark">
              Đồng ý
            </SoftButton>
            <SoftButton onClick={handleClose} color="secondary">
              Đóng
            </SoftButton>
          </Box>
        </Box>
      </Modal>
    </div>
  );
};

export default Actions;
